import crypto from 'crypto';
import axios from 'axios';
const globalConfig = require('../../static/js/config');

/**
 * 获取文件名中 . 后的后缀部分
 * @param {string} filename 文件名
 * @returns 文件格式
 */
export function getFileSuffix(filename) {
  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex !== -1 && lastDotIndex < filename.length - 1) {
    // 提取最后一个 '.' 后面的部分
    return filename.slice(lastDotIndex + 1);
  }
  return null;
}

/**
 * 转换计算机存储容量单位
 * @param size number
 * @param sizeUnit string 单位
 */
export function formatSizeUnit(size, sizeUnit = 'B') {
  const allUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
  const units = allUnits.slice(allUnits.indexOf(sizeUnit));
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length) {
    size = size / 1024;
    unitIndex++;
  }
  return `${Number(size.toFixed(2))}${units[unitIndex]}`;
}

/**
 * 将指定组件设置自定义名称
 * @param {String} name 组件自定义名称
 * @param {Component | Promise<Component>} component
 * @return {Component}
 */
export function createCustomComponent (customName, component) {
  return {
    name: customName,
    data () {
      return { component: null }
    },
    async created () {
      if (component instanceof Promise) {
        try {
          const module = await component
          this.component = module.default
        } catch (error) {
          console.error(`can not resolve component ${name}, error:`, error)
        }
        return
      }
      this.component = component
    },
    render (h) {
      return this.component ? h(this.component) : null
    },
  }
  // VUE3.0
  // return defineComponent({
  //   name: customName,
  //   components: {
  //       AsyncComponent: asyncComponent,
  //   },
  //   setup() {
  //       return () => {
  //           return <AsyncComponent />;
  //       };
  //   },
  // });
}

/**
 * 设置网页名称
 * @param {string} name 路由name
 */
export function setTitle(title) {
  let str = globalConfig.vmpTitle;
  if (title) {
    str += '-' + title;
  }
  document.title = str;
}

/**
 * md5加密密码
 * @param {string} pass 未md5加密的密码
 * @returns 已md5加密的密码
 */
export function passwordBymd5(pass) {
  return crypto.createHash('md5').update(pass, 'utf8').digest('hex');
}

/**
 * 过滤对象中为空的属性
 * @param {object} obj
 * @returns 过滤后的对象
 */
export function filterObj(obj) {
  for(let key in obj) {
    if (
      (typeof obj[key] === 'string' && obj[key].trim() === '')
      || obj[key] === undefined
      || obj[key] === null
    ) {
      delete obj[key];
    }
  }
  return obj;
}

/**
 * base64转Blob
 * @param {string} str 
 */
export function base64ToBlob (str) {
  let parts = str.split(';base64,');
  let contentType = parts[0].split(':')[1];
  let raw = window.atob(parts[1]);
  let rawLength = raw.length;
  let uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], {
    type: contentType
  });
};

/**
 * Blob转base64
 * @param {Blob} blob 
 */
export function blobToBase64 (blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      // const base64Data = reader.result.split(',')[1];
      // // 获取图片格式
      // const mimeType = reader.result.split(',')[0].split(':')[1].split(';')[0];
      // // 添加对应的前缀
      // const base64String = `data:${mimeType};base64,${base64Data}`;
      // resolve(base64String);
      resolve(reader.result);
    };
    reader.onerror = error => reject(error);
  });
  // return URL.createObjectURL(blob);
};

/**
 * bytes转base64
 * @param {string} str
 */
export function bytesToBase64 (str) {
  const bytes = new TextEncoder().encode(str);
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte),
  ).join('');
  return btoa(binString);
};

/**
 * 下载文件
 * @param {Blob} blob
 * @param {String} filename
 */
export function downloadFile (blob, filename) {
  const url = URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};


/**
 * 将毫秒时间转换为 `几天几时几分几秒`
 * @param timediff 起止时间差（毫秒）
 * @returns 返回转换后的时长字符串
 */
export function transTimePeriod (timediff, format = 'D天H时m分') {
	if (typeof timediff !== 'number') return '-'
	const days = Math.floor(timediff / (24 * 60 * 60 * 1000));
	const hdiff = timediff % (24 * 60 * 60 * 1000)
	const hours = Math.floor(hdiff / (60 * 60 * 1000));
	const mdiff = hdiff % (60 * 60 * 1000);
	const minutes = Math.floor(mdiff / (60 * 1000));
	const seconds = Math.floor(mdiff % (60 * 1000) / 1000);

  const opt = {
		'D': days,
		'H': hours,
		'm': minutes,
		's': seconds,
	};
  for (let key in opt) {
    let r = new RegExp('(' + key + ')').exec(format);
    if (r) format = format.replace(r[0], opt[key]).replace(/0[天|D|d|时|H|h](?=\d)/, '');
  }
	return format;
}

// 检测项目是否升级，重新刷新页面
export async function checkVersion() {
  const url = window.location.pathname + 'static/version.json?v=' + new Date().getTime();
  const { data } = await axios.get(url);
  const serverVersion = data ? data.version : null; 
  const localVersion = localStorage.getItem('vmp_version');
  if (serverVersion && serverVersion !== localVersion) {
    localStorage.setItem('vmp_version', serverVersion);
    window.location.reload();
  } else {
    localStorage.setItem('vmp_version', serverVersion);
  }
};




// WEBPACK FOOTER //
// ./src/utils/index.js